// Model.jsx
import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import faq from "../Api/faq";

const ModelParagraph = ({onClose,}) => {
    const modalRef = useRef(null);
    const navigate = useNavigate();
    const handleOutsideClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            onClose();
        }
    };

    useEffect(() => {
        document.body.style.overflow = 'hidden'; // Disable scrolling on the body when the modal is open
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.body.style.overflow = 'auto'; // Re-enable scrolling on the body when the modal is closed
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    const [faqData, setFaqData] = useState(null);

    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    useEffect(() => {
        const fetchDataInfo = async () => {
            try {
                const response = await faq();
                setFaqData(response.data);
            } catch (error) {
                console.error("API Error:", error.message);
                if (error.response.status === 401 || error.response.status === 500) {
                    Toast.fire({
                        icon: 'error',
                        title: error.response.data.title
                    })
                    localStorage.clear();
                    navigate("/");
                }
                Toast.fire({
                    icon: 'error',
                    title: error.response.data.message
                })
            }
        };
        fetchDataInfo();
    }, []);

    const tabs = [
        {
            Deposit: "Please do not use the same personal bank card information to register repeatedly. Once found, it will be processed for a specifc account. Personal multi-account driving sales will lead to the suspension of the seller's store, affecting the seller's reputation, and the sales and sales will be invalid. The platform prohibits one card from being bound to multiple accounts. Do not use multiple personal accounts. One card bound to multiple accounts will cause the funds to be frozen for 90 days and the account will be permanently frozen! The platform is designed to prevent people from maliciously laundering money or cashing out arange of misconduct.  CreditMissionDrawndownPartner Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
        {
            Launch: "Please do not use the same personal bank card information to register repeatedly. Once found, it will be processed for a specifc account. Personal multi-account driving sales will lead to the suspension of the seller's store, affecting the seller's reputation, and the sales and sales will be invalid. The platform prohibits one card from being bound to multiple accounts. Do not use multiple personal accounts. One card bound to multiple accounts will cause the funds to be frozen for 90 days and the account will be permanently frozen! The platform is designed to prevent people from maliciously laundering money or cashing out arange of misconduct.  CreditMissionDrawndownPartner Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
        {
            Withdraw: "Please do not use the same personal bank card information to register repeatedly. Once found, it will be processed for a specifc account. Personal multi-account driving sales will lead to the suspension of the seller's store, affecting the seller's reputation, and the sales and sales will be invalid. The platform prohibits one card from being bound to multiple accounts. Do not use multiple personal accounts. One card bound to multiple accounts will cause the funds to be frozen for 90 days and the account will be permanently frozen! The platform is designed to prevent people from maliciously laundering money or cashing out arange of misconduct.  CreditMissionDrawndownPartner Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",

        },
        {
            Partners: "Please do not use the same personal bank card information to register repeatedly. Once found, it will be processed for a specifc account. Personal multi-account driving sales will lead to the suspension of the seller's store, affecting the seller's reputation, and the sales and sales will be invalid. The platform prohibits one card from being bound to multiple accounts. Do not use multiple personal accounts. One card bound to multiple accounts will cause the funds to be frozen for 90 days and the account will be permanently frozen! The platform is designed to prevent people from maliciously laundering money or cashing out arange of misconduct.  CreditMissionDrawndownPartner Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
    ];

    return (
        <div>
            <div className="modal-overlay"></div>

            <div className="modal fade show" tabIndex="-1" role="dialog" style={{display: 'block'}}>
                <div className="modal-dialog modal-dialog-centered p-3 py-5" ref={modalRef}>
                    <div className="modal-content">
                        <div className="container d-flex flex-column p-4">
                            <span className="fw-bold h6 text-pink mb-2">TeamLewis</span>

                            <span className="fs-1 text-white mb-3">
                                Ask Questions
                            </span>

                            <span className="h5 text-white text-justify"
                                  dangerouslySetInnerHTML={{
                                      __html: faqData?.data,
                                  }}>
                            </span>

                            {/*<nav>*/}
                            {/*    <div className="nav nav-tabs d-flex flex-nowrap" id="nav-tab-faq" role="tablist">*/}
                            {/*        <button className="nav-link active p-1" id="nav-deposit-tab" data-bs-toggle="tab"*/}
                            {/*                data-bs-target="#nav-deposit" type="button" role="tab"*/}
                            {/*                aria-controls="nav-deposit"*/}
                            {/*                aria-selected="true">*/}
                            {/*            <span className='lightGrey fw-bold'>Deposit</span>*/}
                            {/*        </button>*/}
                            {/*        <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab"*/}
                            {/*                data-bs-target="#nav-launch" type="button" role="tab"*/}
                            {/*                aria-controls="nav-launch" aria-selected="false">*/}
                            {/*            <span className='lightGrey fw-bold'>Launch</span>*/}

                            {/*        </button>*/}
                            {/*        <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab"*/}
                            {/*                data-bs-target="#nav-withdraw" type="button" role="tab"*/}
                            {/*                aria-controls="nav-withdraw" aria-selected="false">*/}
                            {/*            <span className='lightGrey fw-bold'>Withdraw</span>*/}
                            {/*        </button>*/}
                            {/*        <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab"*/}
                            {/*                data-bs-target="#nav-partners" type="button" role="tab"*/}
                            {/*                aria-controls="nav-partners" aria-selected="false">*/}
                            {/*            <span className='lightGrey fw-bold'>Partners</span>*/}
                            {/*        </button>*/}
                            {/*    </div>*/}
                            {/*</nav>*/}
                            {/*<div className="tab-content mt-3" id="nav-tabContent">*/}
                            {/*    <div className="tab-pane fade show active text-justify " id="nav-deposit" role="tabpanel"*/}
                            {/*         aria-labelledby="nav-deposit-tab" tabIndex="0">*/}

                            {/*        <span className="fw-bold fs-3 text-white d-block my-2">*/}
                            {/*            Deposit*/}
                            {/*        </span>*/}

                            {/*        <span className="text-white text-break">*/}
                            {/*            {tabs[0]['Deposit']}*/}
                            {/*        </span>*/}
                            {/*    </div>*/}
                            {/*    <div className="tab-pane fade" id="nav-launch" role="tabpanel"*/}
                            {/*         aria-labelledby="nav-launch-tab" tabIndex="0">*/}

                            {/*        <span className="fw-bold fs-3 text-white d-block my-2">*/}
                            {/*            Launch*/}
                            {/*        </span>*/}

                            {/*        <span className="text-white text-break">*/}
                            {/*            {tabs[1]['Launch']}*/}
                            {/*        </span>*/}
                            {/*    </div>*/}
                            {/*    <div className="tab-pane fade" id="nav-withdraw" role="tabpanel"*/}
                            {/*         aria-labelledby="nav-withdraw-tab" tabIndex="0">*/}

                            {/*        <span className="fw-bold fs-3 text-white d-block my-2">*/}
                            {/*            Withdraw*/}
                            {/*        </span>*/}

                            {/*        <span className="text-white text-break">*/}
                            {/*            {tabs[2]['Withdraw']}*/}
                            {/*        </span>*/}
                            {/*    </div>*/}
                            {/*    <div className="tab-pane fade" id="nav-partners" role="tabpanel"*/}
                            {/*         aria-labelledby="nav-partners-tab" tabIndex="0">*/}

                            {/*        <span className="fw-bold fs-3 text-white d-block my-2">*/}
                            {/*            Partners*/}
                            {/*        </span>*/}

                            {/*        <span className="text-white text-break">*/}
                            {/*            {tabs[3]['Partners']}*/}
                            {/*        </span>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModelParagraph;
